import { plainToClass } from "class-transformer";
import { LMSSiteStudyTrainingDto, LMSSiteStudyUserDto, studyIdParam } from "./trainings.objects";

export class LMSSiteStudyDetailsPage {
    trainingsTable: any;
    usersTable: any;
    isShowingUsers: boolean = false;

    constructor(private siteId: number, private studyId: number | null) {
        this.loadData();
        this.initializeTables();
        this.initializeTabs();
    }

    private loadData(): void {
        $.get(`?handler=Trainings&siteId=${this.siteId}${studyIdParam(this.studyId)}`)
            .done((result: LMSSiteStudyTrainingDto[]) => {
                const rows = plainToClass(LMSSiteStudyTrainingDto, result ?? []);
                this.trainingsTable.clear();
                this.trainingsTable.rows.add(rows).draw();
            });

        $.get(`?handler=Users&siteId=${this.siteId}${studyIdParam(this.studyId)}`)
            .done((result: LMSSiteStudyUserDto[]) => {
                const rows = plainToClass(LMSSiteStudyUserDto, result ?? []);
                this.usersTable.clear();
                this.usersTable.rows.add(rows).draw();
            });
    }

    private initializeTables(): void {
        this.trainingsTable = $('#lmsSiteStudyTrainingsTable').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            order: [[0, 'asc']],
            columns: [
                { data: "trainingName", title: "Training", className: "training-name text-nowrap" },
                { data: "overdue", title: "Overdue" },
                { data: "incomplete", title: "Incomplete" },
                { data: "expired", title: "Expired" },
                { data: "complete", title: "Complete" },
                { data: "total", title: "Total" },
            ],
            data: []
        });

        $('#lmsSiteStudyTrainingsTable tbody').on('click', 'tr', (e) => {
            const rowData: LMSSiteStudyTrainingDto = this.trainingsTable.row(e.currentTarget).data();
            if (!rowData) return;

            window.location.href = `/secure/lms/settings/details/training?siteId=${this.siteId}${studyIdParam(this.studyId)}&trainingId=${rowData.trainingId}`;
        });

        this.usersTable = $('#lmsSiteStudyUsersTable').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            order: [[0, 'asc']],
            columns: [
                { data: "userName", title: "User", className: "user-name text-nowrap" },
                { data: "roles", title: "Role" },
                { data: "overdue", title: "Overdue" },
                { data: "incomplete", title: "Incomplete" },
                { data: "expired", title: "Expired" },
                { data: "complete", title: "Complete" },
                { data: "total", title: "Total" },
            ],
            data: []
        });

        $('#lmsSiteStudyUsersTable tbody').on('click', 'tr', (e) => {
            const rowData: LMSSiteStudyUserDto = this.usersTable.row(e.currentTarget).data();
            if (!rowData) return;

            window.location.href = `/secure/lms/settings/details/user?siteId=${this.siteId}${studyIdParam(this.studyId)}&userId=${rowData.userId}`;
        });
    }

    private initializeTabs(): void {
        $('#toggleSiteStudyTrainingsBtn').on('click', () => this.showTrainingsTab());
        $('#toggleSiteStudyUsersBtn').on('click', () => this.showUsersTab());
    }

    private showTrainingsTab(): void {
        if (!this.isShowingUsers) return;

        this.isShowingUsers = false;
        $('#toggleSiteStudyUsersBtn').removeClass('active');
        $('#toggleSiteStudyTrainingsBtn').addClass('active');

        $('#lmsSiteStudyUsersTableContainer').addClass('d-none');
        $('#lmsSiteStudyTrainingsTableContainer').removeClass('d-none');

        this.trainingsTable.columns.adjust();
    }

    private showUsersTab(): void {
        if (this.isShowingUsers) return;

        this.isShowingUsers = true;
        $('#toggleSiteStudyTrainingsBtn').removeClass('active');
        $('#toggleSiteStudyUsersBtn').addClass('active');

        $('#lmsSiteStudyTrainingsTableContainer').addClass('d-none');
        $('#lmsSiteStudyUsersTableContainer').removeClass('d-none');

        this.usersTable.columns.adjust();
    }
}
